<script>
	import { onMount } from 'svelte';
	import Identity from 'svelte-key';
  import { addMessages, loadMessages, fetchData, generateID, loadAccount, loadCacheIndex, hasCache, getCache, cachedFetch, getSavedProjects, setSavedProjects, isTouchEnabled } from '../components/shared/utils/Data.svelte';
  import { projectSort } from '../components/shared/utils/Sort.svelte';
	import { fly } from 'svelte/transition';
	import LoginModal from '../components/shared/modal/Login.svelte';
	import MediaViewModal from '../components/shared/modal/MediaView.svelte';
	import MediaUploadModal from '../components/shared/modal/MediaUpload.svelte';
	import ForbiddenModal from '../components/shared/modal/Forbidden.svelte';
	import SettingsModal from '../components/shared/modal/Settings.svelte';
	import Tree from '../components/project/Sidebar.svelte';
	import Project from '../components/project/Project.svelte';
	import MessageModal from '../components/shared/modal/Message.svelte';
	import MessageViewModal from '../components/shared/modal/MessageView.svelte';
	import InfoModal from '../components/shared/modal/Info.svelte';

	export let vitals;
	export let messageToken;
	let messages = [];
	let tooltips = true;
	let toast = null;
	let banner = true;
	let keys = {
		scene: "1",
		project: "1",
		tree: "1",
		content: "1",
		toast: "1"
	}
	let projectId = "";
	let project = {
		id: "0",
		name: "",
		tree: {},
		media: {}
	};
	let sidebar = true;
	let isPublic = false;
	let projects = [];
	let modal = {
		view: ""
	};
	let session = {
    workspaces: []
	};
	if (localStorage.getItem("session")) {
		session = JSON.parse(localStorage.getItem("session"));
	}
	let contentViews = {
		project: Project
	}
	let modalViews = {
		login: LoginModal,
		mediaView: MediaViewModal,
		mediaUpload: MediaUploadModal,
		forbidden: ForbiddenModal,
		settings: SettingsModal,
		message: MessageModal,
		messageView: MessageViewModal,
		info: InfoModal,
	}
	let settings = {
		newTab: false
	}
	let content = {
        id: "0",
        view: "project"
		};
		
	onMount(async () => {
		if (!isTouchEnabled) {
			tooltips = false;
		}
		var settingsString = localStorage.getItem("settings");
		if (settingsString) {
			settings = JSON.parse(settingsString);
		}
		let params = (new URL(document.location)).searchParams;
		if (params.get("public") !== null) {
			isPublic = true;
		}
		if (params.get("p") !== null) {
			projectId = params.get("p");
		}
		if (isPublic) {
			sidebar = false;
			let [res, err] = await fetchData("/v1/session/project/" + projectId);
			if (err) {
				modal = {
					view: "forbidden"
				};
				return;
			}
			if (res.data) {
				session = res.data;
				getProject();
			}
			else {
				modal = {
					view: "passphrase"
				};
			}
		}
		else if (session.token) {
			getProjects();
			let [res, err] = await fetchData("/v1/session", {
				headers: {
					"Authorization": "Bearer " + session.token,
					"x-message-token": messageToken
				}
			});
			if (err == "invalid or expired jwt") {
				emailAuth()
			}
			else if (!err) {
				session = res.data;
				localStorage.setItem("session", JSON.stringify(session));
			}
		}
		else {
			emailAuth();
		}
  });
	async function emailAuth() {
		let [res, err] = await fetchData("/v1/session/email");
		if (!err) {
			session = res.data;
			localStorage.setItem("session", JSON.stringify(session));
			getProjects();
		}
		else {
			modal = {
				view: "login"
			};
		}
	}
	async function messageHandler(message) {
		if (message.detail.type == "content") {
			content = message.detail.data;
			history.replaceState(null, "", window.location.origin + "?p=" + content.id);
			projectId = content.id;
			getProject();
		}
		else if (message.detail.type == "settings") {
			settings = message.detail.data;
			console.log(settings);
			localStorage.setItem("settings", JSON.stringify(settings));
		}
		else if (message.detail.type == "messages") {
			var data = message.detail.data;
			messages = data.concat(messages);
			addMessages(data);
		}
		else if (message.detail.type == "projects") {
			var data = message.detail.data;
			projects = [data];
			content.name = data.name;
		}
		else if (message.detail.type == "modal") {
			modal = message.detail.data;
		}
		else if (message.detail.type == "filter") {
			keys.project = generateID();
		}
		else if (message.detail.type == "session") {
			session = message.detail.data;
			if (!session.token) {
				localStorage.removeItem("session");
				await fetchData("/v1/session/end", {
					headers: {
						"Authorization": "Bearer " + session.token,
						"x-message-token": messageToken
					}
				});
				projects = [];
				content = {
					id: "",
					view: ""
				};
				modal = {
					view: "login"
				};
			}
			else {
				localStorage.setItem("session", JSON.stringify(session));
				getProjects();
			}
		}
		else if (message.detail.type == "toast") {
			toast = message.detail.data;
			keys.toast = generateID();
			setTimeout(() => toast = null, 5000);
		}
	}
	async function getProjects() {
		projects = [];
		loadAccount(session.account + "_" + session.id, async function () {
			projects = getSavedProjects();
			let [res, err] = await fetchData("/v1/projects", {
			headers: {
				"Authorization": "Bearer " + session.token
			}
		});
		if (err) {
			return;
		}
		projects = res.data.projects;
		setSavedProjects(projects);
		if (projectId) {
			getProject();
		}
		});
	}
	async function getProject() {
		project = {
			id: "0",
			name: "",
			tree: {},
			media: {}
		};
		loadCacheIndex(session.account, function () {
			if (hasCache("project", session.id + "_" + projectId)) {
				getCache("project", session.id + "_" + projectId, function (projectData) {
					initProject(projectData);
					cachedFetch("/v1/projects/" + projectId, "project", session.id, projectId, {
						headers: {
								'Authorization': 'Bearer ' + session.token
						}
					});
				})
			}
			else {
				cachedFetch("/v1/projects/" + projectId, "project", session.id, projectId, {
					headers: {
							'Authorization': 'Bearer ' + session.token
					}
				}, function ([res, err]) {
						if (err) {
								console.log(err);
								return;
						}
						else if (res) {
							initProject(res);
						}
				});
			}
		})
	}
	function initProject(res) {
		if (res.data.tree["maps"] && res.data.tree["scenes"] && res.data.tree["forms"])
			return;
		else {
			project = res.data;
			project.id = projectId;
			keys.content = generateID();
		}
	}
	function toggleSidebar() {
		sidebar = !sidebar;
	}
	function toggleBanner(e) {
		e.currentTarget.blur();
		banner = !banner;
	}
	function closeToast() {
		toast = null;
	}
</script>

<div class="app off-canvas {sidebar ? "off-canvas-sidebar-show" : ""}">
	{#if modal}
		<svelte:component tooltips={tooltips} isPublic={isPublic} settings={settings} this={modalViews[modal.view]} modal={modal} session={session} messageToken={messageToken} on:message={messageHandler} />
	{/if}
	
	{#if toast}
		<Identity key={keys.toast}>
			<div id="toast" class="toast toast-primary"  on:click={closeToast}  transition:fly="{{ y: 100, duration: 500 }}">
				<button class="btn btn-clear float-right"></button>
				{toast.message}
			</div>
		</Identity>
	{/if}
	<div id="sidebar" class="off-canvas-sidebar {sidebar ? "active" : ""}">
		<div id="toggle-container">
			<button id="toggle" on:click={toggleSidebar} class="btn btn-primary btn-sm">
				<i class="icon {sidebar ? "icon-arrow-left" : "icon-arrow-right"}"></i>	
			</button>
		</div>
		<Identity key={session.account}>
			<Tree tooltips={tooltips} vitals={vitals} content={content} keys={keys} projects={projects} settings={settings} session={session} on:message={messageHandler} messages={messages} />
		</Identity>
	</div>
	<div class="off-canvas-content">
		{#if content}
			<Identity key={keys.content}>
				<svelte:component tooltips={tooltips} settings={settings} this={contentViews[content.view]} keys={keys} project={project} isPublic={isPublic} on:message={messageHandler} />
			</Identity>
		{/if}
	</div>
</div>

<style>
	#toggle-container {
		position: fixed;
		width: 300px;
	}
	#toggle {
		position: absolute;
		right: 0;
		top: 0.15rem;
		margin-right: -1.4rem;
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}
	.app {
		min-height: 100vh;
	}
	.off-canvas-sidebar {
		width: 300px;
	}
	#toast {
		position: fixed;
		right: 1rem;
		bottom: 1rem;
		width: 300px;
	}
	#sidebar {
		overflow: visible;
	}
	.off-canvas .off-canvas-content {
		padding: 0;
		max-width: 100%;
	}
</style>